import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import * as fromProfile from '../../store/profile.reducers';
import {Chart} from 'angular-highcharts';
import {Store} from '@ngrx/store';
import * as fromApp from '../../../store/app.reducers';
import {ProfileService} from '../../profile.service';
import {ChartService} from '../../chart.service';

@Component({
    selector: 'app-profile-media-activity-chart',
    templateUrl: './profile-media-activity-chart.component.html',
    styleUrls: ['./profile-media-activity-chart.component.scss'],
    standalone: false
})
export class ProfileMediaActivityChartComponent implements OnInit, OnDestroy {

  profileState: Observable<fromProfile.State>;
  charts: Chart[];
  profileSubscription: Subscription;
  metric = 'doc_count';
  key = 'day';
  prefix = 'post';
  stats: any;

  constructor(
    private store: Store<fromApp.AppState>,
    private profileService: ProfileService
  ) { }

  ngOnInit() {
    this.profileState = this.store.select('profile');

    this.profileSubscription = this.store.select('profile').subscribe(
      (state: fromProfile.State) => {
        if (state.mediaAnalyze !== null) {
          this.stats = state.mediaAnalyze;
          this.renderChart(
            true,
            this.key,
            this.metric
          );

        }

      }
    );
  }

  setKey(key: string) {
    this.key = key;

    this.renderChart(
      true,
      this.key,
      this.metric
    );
  }

  setMetric(metric: string) {
    if (metric === 'post') {
      this.metric = 'doc_count';
      this.prefix = 'post';
    } else if (metric === 'like') {
      this.metric = 'like_sum';
      this.prefix = 'like';
    } else if (metric === 'comment') {
      this.metric = 'comment_sum';
      this.prefix = 'comment';
    } else if (metric === 'reach') {
      this.metric = 'reach_sum';
      this.prefix = 'reach';
    }
    this.renderChart(
      true,
      this.key,
      this.metric
    );
  }

  renderChart(reset: boolean, key: string, metric: string) {
    if (reset) {
      this.charts = [];
    }
    this.charts.push(
      ChartService.getChartDate(this.stats, this.key, this.metric)
    );
  }

  ngOnDestroy() {
    this.profileSubscription.unsubscribe();
  }


}
